<template>
  <div>
    <title-bar title="节电率统计">
      <el-button type="default" @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <el-form v-model="queryForm" inline>
        <el-form-item label="所属单位">
          <comp-select v-model="queryForm.compId" @change="query"></comp-select>
        </el-form-item>
        <el-form-item label="统计年月">
          <el-date-picker v-model="queryForm.yearMonth" type="month"
                          :clearable="false"
                          value-format="yyyy-MM"
                          @change="query"
                          format="yyyy年MM月"></el-date-picker>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model.trim="queryForm.deviceCode"></el-input>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" align="center" min-width="120"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="120"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="150"></el-table-column>
        <el-table-column prop="weekCount" label="周数" align="center" min-width="70"></el-table-column>
        <el-table-column prop="kwh" label="本月电表(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="monthKwh" label="实际耗电(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="originKwh" label="原始耗电(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="saveKwh" label="节电量(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="price" label="电价(元)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="saveMoney" label="节电金额(元)" align="center" min-width="90"></el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect";
export default {
  components: {CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      queryForm: {
        compId: '',
        deviceCode: '',
        yearMonth: new Date().format("yyyy-MM"),
        y: null,
        m: null,
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.queryForm.y = this.queryForm.yearMonth.split("-")[0];
      this.queryForm.m = this.queryForm.yearMonth.split("-")[1];
      this.postForm("/device-month-info/list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>